import { Component, Input } from '@angular/core';
import { ServiceIcons } from './enum/ServiceIcons.enum';
import { ProductKey } from 'src/app/core/enums/ProductKey';
import { SERVICE_ICONS } from 'src/app/core/constants/ServiceIconByProductKey';

@Component({
  selector: 'app-service-icons',
  templateUrl: './service-icons.component.html',
  styleUrls: ['./service-icons.component.scss'],
})
export class ServiceIconsComponent {
  @Input() serviceIconsValue = 0;
  @Input() isDatatable = false;
  @Input() isActiveRouteMap = false;

  @Input() newServiceIcons = false;
  @Input() ServiceProductKey!: ProductKey;

  ProductKey = ProductKey;
  SERVICE_ICONS = SERVICE_ICONS

  serviceIconsEnum = ServiceIcons;

  getIconPath(icon: ServiceIcons): string {
    switch (icon) {
      case ServiceIcons.Transfer:
        return '../../../assets/transfer.svg';
      case ServiceIcons.Parking:
        return '../../../assets/parking.svg';
      case ServiceIcons.Refueling:
        return '../../../assets/refueling.svg';
      case ServiceIcons.MechanicalInspection:
        return '../../../assets/itv-homologacion.svg';
      case ServiceIcons.PreTechnicalInspection:
        return '../../../assets/pre-itv.svg';
      case ServiceIcons.LongDistanceTransfer:
        return '../../../assets/transfer.svg';
      case ServiceIcons.TechnicalInspection:
        return '../../../assets/itv-españa.svg';
      case ServiceIcons.VehicleInsurance:
        return '../../../assets/seguro.svg';
      case ServiceIcons.VehicleDataCollection:
        return '../../../assets/lista-comprobacion.svg';
      case ServiceIcons.Accessory:
        return '../../../assets/cafler-fresh.svg';
      case ServiceIcons.Valet:
        return '../../../assets/valet.svg';
      case ServiceIcons.Tyres:
        return '../../../assets/neumaticos.svg';
      case ServiceIcons.Formalities:
        return '../../../assets/formalities.svg';
      case ServiceIcons.ReplacementVehicle:
        return '../../../assets/vehiculo-de-sustitucion.svg';
      case ServiceIcons.TowTruck:
        return '../../../assets/grua.svg';
      case ServiceIcons.WhateverYouWant:
        return '../../../assets/pide-lo-que-necesites.svg';
      case ServiceIcons.VehicleWash:
        return '../../../assets/lavados.svg';
      case ServiceIcons.VehicleStorage:
        return '/assets/campa.svg';
      default:
        return '../../../assets/transfer.svg';
    }
  }

  getAltText(icon: ServiceIcons): string {
    switch (icon) {
      case ServiceIcons.Transfer:
        return 'Transfer';
      case ServiceIcons.Parking:
        return 'Parking';
      case ServiceIcons.Refueling:
        return 'Refueling';
      case ServiceIcons.MechanicalInspection:
        return 'Mechanical inspection';
      case ServiceIcons.PreTechnicalInspection:
        return 'Pre technical inspection';
      // TODO: revisar icono, no correcto
      case ServiceIcons.LongDistanceTransfer:
        return 'Long disntance transfer';
      case ServiceIcons.TechnicalInspection:
        return 'Technical inspection';
      case ServiceIcons.VehicleInsurance:
        return 'vehicle insurance';
      case ServiceIcons.VehicleDataCollection:
        return 'Vehicle data collection';
      // TODO: revisar icono, no correcto
      case ServiceIcons.Accessory:
        return 'Accessory';
      case ServiceIcons.Valet:
        return 'Valet';
      case ServiceIcons.Tyres:
        return 'Tyres';
      // TODO: revisar icono, no correcto
      case ServiceIcons.Formalities:
        return 'Formalities';
      case ServiceIcons.ReplacementVehicle:
        return 'Replacement vehicle';
      case ServiceIcons.TowTruck:
        return 'Tow truck';
      case ServiceIcons.WhateverYouWant:
        return 'What ever you want';
      case ServiceIcons.VehicleWash:
        return 'Vehicle wash';
      default:
        return 'No image';
    }
  }
}
